import { render, staticRenderFns } from "./DisplayResourceConfig.vue?vue&type=template&id=2bb58751&"
import script from "./DisplayResourceConfig.vue?vue&type=script&lang=js&"
export * from "./DisplayResourceConfig.vue?vue&type=script&lang=js&"
import style0 from "./DisplayResourceConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports